module.exports = __webpack_public_path__ + "../resources/img/ic_re_disconnected_product_default.a9d82577.svg";